import { render, staticRenderFns } from "./basregisterSingle.vue?vue&type=template&id=4b0885c6&"
import script from "./basregisterSingle.vue?vue&type=script&lang=js&"
export * from "./basregisterSingle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports